import React, { CSSProperties } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import SectionTitle from 'flow/components/nav/list-items/SectionTitle';

interface Props {
    style: CSSProperties;
    labelKey: string;
}

const MentionPickerHeading = ({ style, labelKey }: Props) => {
    const { i18next } = useAppContext();

    // SectionTitle indents by ps-2. The extra ps-1 lines the text up with the
    // px-3 of the colleague rows.
    return (
        <div style={style} className="ps-1">
            <SectionTitle>{i18next.t(labelKey)}</SectionTitle>
        </div>
    );
};

export default React.memo(MentionPickerHeading);
